import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import CityComponent from "@/pages/Cities/CityComponents/Cities/CityComponent";
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import { PageNamesEnum } from "@/routes/routes";
var CitiesPage = function CitiesPage() {
  var citiesData = useFullPageData(PageNamesEnum.PAGE_NAME__Cities);
  if (!citiesData) return null;
  return /*#__PURE__*/React.createElement(Layout, {
    headHideLinks: true,
    hasNavBar: true,
    authenticationMsg: true,
    mainClass: "",
    linksForSearch: true,
    hideOrangeHeadBtn: true,
    disableLoader: true,
    hideAppBanner: true,
    hasMobFooter: true,
    loading: true
  }, /*#__PURE__*/React.createElement(CityComponent, {
    citiesData: citiesData
  }));
};
export default CitiesPage;